
import React from 'react';
import Select from 'react-select';
import { useIsMobile } from '@/hooks/use-mobile';
import { WorksheetOption } from './types';
import { customStyles } from '../../SelectStyles';
import WorksheetOptionLabel from './WorksheetOptionLabel';
import { useTranslation } from 'react-i18next';

interface WorksheetSelectorProps {
  options: WorksheetOption[];
  value: WorksheetOption | null;
  onChange: (option: WorksheetOption | null) => void;
  onInputChange: (inputValue: string) => void;
  isLoading: boolean;
  disabled: boolean;
}

const WorksheetSelector: React.FC<WorksheetSelectorProps> = ({
  options,
  value,
  onChange,
  onInputChange,
  isLoading,
  disabled
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  // Format option label with status badge
  const formatOptionLabel = (option: WorksheetOption) => (
    <WorksheetOptionLabel option={option} />
  );

  return (
    <Select<WorksheetOption>
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      isLoading={isLoading}
      isClearable={true}
      placeholder={t('form.fields.worksheetSearchPlaceholder')}
      noOptionsMessage={() => t('form.fields.searchMin2Chars')}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      className="react-select-container"
      classNamePrefix="react-select"
      menuPlacement={isMobile ? "auto" : "bottom"}
      menuPosition="fixed"
      isDisabled={disabled}
    />
  );
};

export default WorksheetSelector;
